import type { WhatsNewRelease } from "models/whats-new";
import { type RequestState, useAuthenticatedRequest } from "./request";

/**
 * Fetches the current "What's New" release from the backend
 * (`GET /v0/config/whats-new`, CX-3628). The endpoint is audience-gated
 * server-side: it returns the release for an in-audience caller and a 204
 * (empty body) otherwise, so the caller never has to derive the audience
 * itself. Media `src`/`fallbackSrc` are already absolute URLs in the response.
 *
 * @param shouldLoad - when false the request is not fired (used to defer the
 *   authenticated call until the onboarding gate has settled and the viewer is
 *   allowed to see the popup)
 * @returns the request state tuple `[release, error, isLoading]`; `release` is
 *   an empty string on a 204 response, which {@link useWhatsNew} coerces to null
 */
export function useWhatsNewRelease(
  shouldLoad: boolean,
): RequestState<WhatsNewRelease> {
  return useAuthenticatedRequest<WhatsNewRelease>(
    "/v0/config/whats-new",
    undefined,
    shouldLoad,
  );
}
